import { useContext, useEffect, useMemo, useState } from "react";
import Modal from "../../../components/global/Modal"
import axios from "../../../components/api/axios";
import DataContext from "../../../context/DataContext";
import { privacyLink, termsLink } from "../../../components/ui library/helpers/consts";
import ResponseModal from "../../../components/global/ResponseModal";

const ConditionsModal = () => {
  const privacyKey = "accepted_privacy_2025_05"
  const termsKey = "accepted_terms_2025_05"
  const { accessToken, loggedInUser } = useContext(DataContext);
  const [openModal, setOpenModal] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorArray, setErrorArray] = useState([]);
  const [isPrivacy, setIsPrivacy] = useState(false);
  const hasAcceptedPrivacy = useMemo(() => loggedInUser?.attributes && !!loggedInUser.attributes[privacyKey], [loggedInUser]);
  const hasAcceptedTerms = useMemo(() => loggedInUser?.attributes && !!loggedInUser.attributes[termsKey], [loggedInUser]);

  const handleSubmit = async () => {
    try {
      const body = {
        ...( !hasAcceptedPrivacy && {[privacyKey]: new Date()}),
        ...( !hasAcceptedTerms && {[termsKey]: new Date()})
      }
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${accessToken}`,
      };
      await axios
        .post(
          `api/users/${loggedInUser.pk}/attributes/`,
          body, 
          { headers }
        )
        setOpenModal(false);
    } catch (error) {
      setOpenError(true);
      setErrorArray(error);
    }

  }

  useEffect(() => {
    if (!hasAcceptedPrivacy || !hasAcceptedTerms) {
      setOpenModal(true);
      if (!hasAcceptedPrivacy) {
        setIsPrivacy(true);
        return;
      }
      if (!hasAcceptedTerms) {
        setIsPrivacy(false);
      }
    }
  }, [hasAcceptedPrivacy, hasAcceptedTerms])
  
  return (
    <>
      <Modal
        open={openModal}
        maxWidth="sm"
        closable={false}
        actions={[
          {
            onClick: isPrivacy ? () => setIsPrivacy(false) : () => handleSubmit(),
            label: "Acknowledge",
            className: "bg-blue-600 text-white hover:bg-blue-700 disabled:text-white disabled:bg-blue-400",
          },
        ]}
      >
        <iframe
          src={isPrivacy ? privacyLink : termsLink}
          width="100%"
          height="500px"
          title="PDF Viewer"
        />
      </Modal>
      <ResponseModal
        title="Something went wrong"
        isError={true}
        openBool={openError}
        setOpenBool={setOpenError}
        errorMessage={errorArray}
      />
    </>
  )
}

export default ConditionsModal